import { adminVerificationQueryKeys as e } from "./adminVerificationQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { verificationApi as r } from "@maat/api-main";
//#region src/verification/admin/useResolveDocumentRemovalMutation.ts
var i = (i, a) => {
	let o = n();
	return t({
		mutationFn: ({ documentId: e, payload: t }) => r.adminResolveDocumentRemoval(e, t),
		onSuccess: () => {
			o.invalidateQueries({ queryKey: e.detail(i, a) });
		}
	});
};
//#endregion
export { i as useResolveDocumentRemovalMutation };
